export const TR_RECIPE_OVERRIDES = {
  "Karnıyarık": {
    kategori: "Ana Yemek", sure: "65 dk", porsiyon: "4 kişilik",
    malzemeler: ["4 orta boy patlıcan", "400 g orta yağlı kıyma", "1 büyük kuru soğan", "2 adet sivri biber", "2 adet domates", "2 diş sarımsak", "1 yemek kaşığı domates salçası", "4 yemek kaşığı zeytinyağı", "1 çay kaşığı tuz", "½ çay kaşığı karabiber"],
    yapilis: [
      "Patlıcanları alacalı soyup ortalarına boydan çizik atın; tuzlu suda 15 dakika bekletip iyice kurulayın.",
      "Patlıcanları az yağla tavada çevirerek veya 200°C fırında 20 dakika yumuşayana kadar pişirin.",
      "İç harç için soğanı ve biberi 2 yemek kaşığı yağda yumuşatın; kıymayı ekleyip tane tane olana kadar kavurun.",
      "Sarımsak, küp domates, salçanın yarısı, tuz ve karabiberi ekleyip harcı 8-10 dakika suyunu çekene kadar pişirin.",
      "Patlıcanları fırın kabına alın, çizik yerlerini kaşıkla açın ve kıymalı harcı eşit biçimde doldurun.",
      "Kalan salçayı 1 su bardağı sıcak suyla açıp kabın kenarından dökün; 190°C fırında 20-25 dakika pişirin.",
      "Fırından çıkınca 5 dakika dinlendirip cacık veya pilavla servis edin.",
    ],
  },
  "İmam Bayıldı": {
    kategori: "Ana Yemek", sure: "70 dk", porsiyon: "4 kişilik",
    malzemeler: ["4 orta boy patlıcan", "3 büyük kuru soğan", "4 diş sarımsak", "3 adet domates", "1 tatlı kaşığı domates salçası", "6 yemek kaşığı zeytinyağı", "½ demet maydanoz", "1 çay kaşığı tuz", "½ çay kaşığı toz şeker", "½ su bardağı sıcak su"],
    yapilis: [
      "Patlıcanları alacalı soyup ortalarına boydan çizik atın; tuzlu suda 15 dakika bekletip kurulayın.",
      "Patlıcanları zeytinyağının yarısıyla tavada veya 200°C fırında yumuşayana kadar pişirin.",
      "Soğanları piyazlık doğrayıp kalan yağda 8-10 dakika yumuşatın; sarımsak ve küp domatesi ekleyin.",
      "Salça, tuz ve şekeri ekleyip iç harcı domates suyunu hafif çekene kadar pişirin; maydanozu ocaktan alınca karıştırın.",
      "Patlıcanların içini nazikçe açıp soğanlı harcı doldurun ve fırın kabına dizin.",
      "Sıcak suyu kabın kenarından ekleyip 180°C fırında 25 dakika pişirin.",
      "Kendi kabında ılındırın; üzerine zeytinyağı gezdirip oda sıcaklığında servis edin.",
    ],
  },
  "Patlıcan Musakka": {
    kategori: "Ana Yemek", sure: "60 dk", porsiyon: "4 kişilik",
    malzemeler: ["4 orta boy patlıcan", "400 g orta yağlı kıyma", "1 büyük kuru soğan", "2 adet sivri biber", "2 adet domates", "1 yemek kaşığı domates salçası", "3 yemek kaşığı zeytinyağı", "1 su bardağı sıcak su", "1 çay kaşığı tuz", "½ çay kaşığı karabiber"],
    yapilis: [
      "Patlıcanları alacalı soyup 1,5 cm kalınlığında dilimleyin; tuzlu suda bekletip kurulayın.",
      "Patlıcanları az yağla tavada çevirin veya 200°C fırında 15-20 dakika hafif kızartın.",
      "Soğan ve biberi yağda yumuşatın; kıymayı ekleyip suyunu çekene kadar kavurun.",
      "Domates, salça, tuz ve karabiberi ekleyip harcı 8 dakika pişirin.",
      "Tencereye patlıcan ve kıymalı harcı kat kat yerleştirin; sıcak suyu kenardan ekleyin.",
      "Kapağı kapalı olarak kısık ateşte 20-25 dakika, patlıcanlar tamamen yumuşayana kadar pişirin.",
      "10 dakika dinlendirip pirinç pilavı veya cacıkla servis edin.",
    ],
  },
  "Hünkâr Beğendi": {
    kategori: "Ana Yemek", sure: "85 dk", porsiyon: "4 kişilik",
    malzemeler: ["600 g kuşbaşı dana eti", "1 büyük kuru soğan", "2 adet sivri biber", "2 adet domates", "1 yemek kaşığı domates salçası", "4 orta boy patlıcan", "2 yemek kaşığı tereyağı", "2 yemek kaşığı un", "2 su bardağı süt", "100 g rendelenmiş kaşar", "Tuz, karabiber"],
    yapilis: [
      "Eti kızgın tencerede partiler hâlinde mühürleyin; soğan ve biberi ekleyip yumuşatın.",
      "Salça ve domatesi ekleyip 2 dakika pişirin; 2 su bardağı sıcak su ekleyerek eti kısık ateşte yumuşatın.",
      "Patlıcanları ocakta veya 230°C fırında kabukları yanıp içleri yumuşayana kadar közleyin; soyup ince kıyın.",
      "Ayrı tencerede tereyağını eritip unu 2 dakika kokusu çıkana kadar kavurun.",
      "Sütü azar azar ekleyip çırpın; koyulaşınca patlıcanı ve kaşarı ekleyip pürüzsüz bir beğendi hazırlayın.",
      "Etin tuz ve karabiberini ayarlayıp sosunu kıvamlandırın; beğendiyi servis tabağına yayın.",
      "Yumuşak eti beğendinin üzerine alıp sıcak servis edin.",
    ],
  },
  "Ali Nazik": {
    kategori: "Ana Yemek", sure: "60 dk", porsiyon: "4 kişilik",
    malzemeler: ["500 g orta yağlı kıyma veya küçük doğranmış kuşbaşı et", "4 orta boy patlıcan", "2 su bardağı süzme yoğurt", "2 diş sarımsak", "1 büyük kuru soğan", "1 yemek kaşığı domates salçası", "2 yemek kaşığı tereyağı", "1 çay kaşığı tuz", "½ çay kaşığı karabiber", "½ çay kaşığı pul biber"],
    yapilis: [
      "Patlıcanları közleyip kabuklarını soyun; suyunu süzdürüp bıçakla ince kıyın.",
      "Yoğurdu ezilmiş sarımsak ve tuzla karıştırın; patlıcan tamamen ılınınca yoğurda ekleyin.",
      "Soğanı tereyağında yumuşatın; kıyma veya eti ekleyip yüksek ateşte renk alana kadar pişirin.",
      "Salça, karabiber ve az sıcak su ekleyip et tamamen pişene kadar 8-10 dakika sürdürün.",
      "Yoğurtlu patlıcanı servis tabağına yayın; sıcak etli harcı üzerine yerleştirin.",
      "Pul biberli tereyağı gezdirin ve yoğurdu bekletmeden servis edin.",
    ],
  },
  "Mantı": {
    kategori: "Ana Yemek", sure: "95 dk", porsiyon: "4-6 kişilik",
    malzemeler: ["3 su bardağı un", "1 adet yumurta", "1 çay kaşığı tuz", "¾ su bardağı ılık su", "250 g orta yağlı kıyma", "1 küçük kuru soğan", "500 g yoğurt", "2 diş sarımsak", "2 yemek kaşığı tereyağı", "1 tatlı kaşığı pul biber", "1 tatlı kaşığı kuru nane"],
    yapilis: [
      "Un, yumurta, tuz ve suyla sertçe bir hamur yoğurun; üzerini kapatıp 30 dakika dinlendirin.",
      "İç harç için kıyma, çok ince rendelenmiş soğan, tuz ve karabiberi karıştırın.",
      "Hamuru iki bezeye ayırıp 1-1,5 mm kalınlığında açın ve yaklaşık 2,5 cm karelere kesin.",
      "Her karenin ortasına az miktarda harç koyup dört köşesini merkezde sıkıca birleştirin.",
      "Geniş tencerede tuzlu suyu kaynatın; mantıları ekleyip hamur yumuşayana ve kıyma tamamen pişene kadar 10-12 dakika haşlayın.",
      "Yoğurdu ezilmiş sarımsakla karıştırın; tereyağında pul biber ve naneyi kısa süre kızdırın.",
      "Mantıyı süzüp sarımsaklı yoğurt ve baharatlı tereyağıyla hemen servis edin.",
    ],
  },
  "Lahmacun": {
    kategori: "Ana Yemek", sure: "90 dk", porsiyon: "8 adet",
    malzemeler: ["4 su bardağı un", "1 paket instant maya", "1½ su bardağı ılık su", "1 çay kaşığı tuz", "400 g orta yağlı kıyma", "2 adet domates", "2 adet sivri biber", "1 büyük kuru soğan", "2 diş sarımsak", "1 yemek kaşığı domates salçası", "½ demet maydanoz", "Pul biber, karabiber, kimyon"],
    yapilis: [
      "Un, maya, tuz ve ılık suyla yumuşak bir hamur yoğurun; üzerini kapatıp 45 dakika mayalandırın.",
      "Soğan, biber, domates, sarımsak ve maydanozu çok ince doğrayın veya kısa aralıklarla rondodan geçirin.",
      "Sebze karışımını kıyma, salça ve baharatlarla yoğurun; sürülebilir olması için gerekirse 2-3 yemek kaşığı su ekleyin.",
      "Hamuru 8 bezeye ayırıp çok ince, oval veya yuvarlak açın.",
      "Kıymalı harcı kenarlara kadar ince bir tabaka hâlinde yayın.",
      "Önceden 250°C'ye ısıtılmış fırında kızgın tepsi veya taş üzerinde 6-8 dakika; kıyma tamamen pişene kadar pişirin.",
      "Maydanoz, soğan, domates ve limonla sıcak servis edin.",
    ],
  },
};

export const EN_RECIPE_OVERRIDES = {
  "Cottage Pie": {
    kategori: "Main Dish", sure: "65-75 min", porsiyon: "4 servings",
    malzemeler: ["600 g lean minced beef", "1 medium onion", "2 carrots", "2 celery sticks", "1 tbsp tomato paste", "500 ml / 2 cups beef stock", "150 g peas", "1 kg potatoes", "50 g butter", "100 ml milk", "Salt and black pepper"],
    yapilis: [
      "Boil peeled, evenly cut potatoes in salted water until tender, then drain well.",
      "Brown the beef in a wide pan; add diced onion, carrots and celery and cook for 6-8 minutes.",
      "Stir in tomato paste, add stock and simmer until the filling is thick rather than watery; fold in peas.",
      "Mash the hot potatoes with butter and milk and season until smooth.",
      "Spoon the beef filling into a baking dish, spread mash on top and roughen the surface with a fork.",
      "Bake at 200°C / 400°F for 25-30 minutes until bubbling and golden.",
      "Rest for 8-10 minutes before serving with green vegetables.",
    ],
  },
  "Moussaka": {
    kategori: "Main Dish", sure: "90 min", porsiyon: "6 servings",
    malzemeler: ["3 medium aubergines", "500 g minced lamb or beef", "1 medium onion", "2 garlic cloves", "2 x 400 g cans chopped tomatoes", "1 tsp dried oregano", "40 g butter", "40 g plain flour", "500 ml milk", "1 large egg", "80 g grated cheese", "Olive oil, salt and pepper"],
    yapilis: [
      "Slice the aubergines, lightly salt for 15 minutes, pat dry and brush with olive oil.",
      "Roast at 220°C / 425°F for 20-25 minutes, turning once, until tender and lightly browned.",
      "Brown the mince; add onion and garlic, then tomatoes and oregano and simmer until thick.",
      "Make a béchamel by cooking butter and flour for 2 minutes, then gradually whisking in milk until smooth and thick.",
      "Cool the sauce slightly, whisk in the egg and half the cheese, and season.",
      "Layer aubergine and meat sauce in a baking dish, finish with béchamel and remaining cheese.",
      "Bake at 190°C / 375°F for 35-40 minutes; rest for 15 minutes before slicing.",
    ],
  },
  "Bangers and Mash": {
    kategori: "Main Dish", sure: "45 min", porsiyon: "4 servings",
    malzemeler: ["8 good-quality pork sausages", "1 kg floury potatoes", "60 g butter", "150 ml warm milk", "2 large onions", "1 tbsp plain flour", "500 ml / 2 cups beef or vegetable stock", "1 tsp Worcestershire sauce", "Salt and black pepper"],
    yapilis: [
      "Brown the sausages in a wide pan over medium heat, then cook through gently, turning regularly.",
      "Boil peeled, evenly cut potatoes in salted water for 15-20 minutes until tender.",
      "Drain potatoes, let steam escape for 2 minutes, then mash with butter and warm milk.",
      "For the gravy, slowly cook sliced onions in the sausage pan until deeply golden.",
      "Stir flour into the onions, gradually add stock and Worcestershire sauce, and simmer until glossy.",
      "Confirm the sausages are cooked through, return them to the gravy and heat for 2 minutes.",
      "Serve two sausages per person over mash with onion gravy and green vegetables.",
    ],
  },
  "Toad in the Hole": {
    kategori: "Main Dish", sure: "55 min", porsiyon: "4 servings",
    malzemeler: ["8 pork sausages", "140 g / 1 cup plain flour", "4 large eggs", "200 ml milk", "½ tsp salt", "2 tbsp cooking oil", "Onion gravy and green vegetables to serve"],
    yapilis: [
      "Whisk flour, eggs, milk and salt into a smooth batter and rest it for 20-30 minutes.",
      "Heat the oven to 220°C / 425°F and add oil and sausages to a sturdy roasting tin.",
      "Roast sausages for 15 minutes until starting to brown and the oil is very hot.",
      "Working quickly, pour the batter around the sausages and return the tin to the oven.",
      "Bake for 25-30 minutes without opening the door until deeply risen and crisp.",
      "Check the sausages are cooked through and serve immediately with onion gravy and greens.",
    ],
  },
  "Pancakes with Bacon": {
    kategori: "Main Dish", sure: "35 min", porsiyon: "4 servings",
    malzemeler: ["250 g / 2 cups plain flour", "1 tbsp baking powder", "½ tsp salt", "2 large eggs", "500 ml / 2 cups milk", "2 tbsp melted butter", "8 rashers bacon", "Fresh fruit and maple syrup to serve"],
    yapilis: [
      "Cook bacon in a wide pan or 200°C / 400°F oven until browned and fully cooked; keep warm.",
      "Whisk flour, baking powder and salt in a bowl; whisk eggs, milk and melted butter separately.",
      "Pour wet ingredients into dry and fold only until no dry flour remains; small lumps are fine.",
      "Rest the batter for 10 minutes while heating a lightly greased non-stick pan over medium heat.",
      "Cook small ladles of batter until bubbles form and edges set, then flip and cook the second side.",
      "Keep cooked pancakes warm in a low oven and repeat without pressing them flat.",
      "Serve with crisp bacon, fresh fruit and a small amount of maple syrup.",
    ],
  },
  "French Toast with Fruit": {
    kategori: "Main Dish", sure: "25 min", porsiyon: "4 servings",
    malzemeler: ["8 thick slices day-old bread", "4 large eggs", "250 ml / 1 cup milk", "1 tsp vanilla", "1 tsp cinnamon", "1 tbsp butter", "400 g mixed fresh fruit", "Plain yogurt to serve"],
    yapilis: [
      "Wash and cut the fruit and keep it chilled while preparing the toast.",
      "Whisk eggs, milk, vanilla and cinnamon in a wide shallow dish.",
      "Dip each bread slice briefly on both sides so it absorbs custard without becoming fragile.",
      "Melt a little butter in a non-stick pan over medium-low heat.",
      "Cook bread for 3-4 minutes per side until golden and the egg mixture is fully set inside.",
      "Keep slices warm while cooking the remainder and wipe the pan if butter begins to darken.",
      "Serve immediately with fresh fruit and plain yogurt.",
    ],
  },
  "Cobb Salad Dinner": {
    kategori: "Main Dish", sure: "30 min", porsiyon: "4 servings",
    malzemeler: ["500 g cooked chicken breast", "2 romaine lettuces", "4 hard-boiled eggs", "8 rashers cooked bacon", "250 g cherry tomatoes", "1 avocado", "100 g blue cheese or cheddar", "3 tbsp olive oil", "1½ tbsp red wine vinegar", "1 tsp Dijon mustard"],
    yapilis: [
      "Wash and thoroughly dry the lettuce; chop it into bite-size pieces.",
      "Slice the cooked chicken, eggs, bacon, tomatoes and avocado into neat pieces.",
      "Whisk olive oil, vinegar, mustard, salt and pepper into an emulsified dressing.",
      "Spread lettuce over a large platter and arrange each topping in separate rows.",
      "Crumble cheese over the top and add dressing immediately before serving.",
      "Toss at the table or serve arranged, keeping any leftovers undressed.",
    ],
  },
};

